import { type UseFormRegisterReturn } from 'react-hook-form'
import { Input } from '@/components/ui/input'

type Props = {
  label: string
  dateField: UseFormRegisterReturn
  timeField?: UseFormRegisterReturn
  timeLabel?: string
  labelClassName?: string
}

// ネイティブ日時入力のモバイル崩れ対策をまとめたクラス。
// - h-10           : iOS/Android のネイティブ chrome が縦詰まりしない高さを確保
// - appearance-none : ネイティブ枠の固有最小幅を抑制し flex で縮められるようにする
// - date-and-time-value:text-left      : 値の中央寄り詰まりを左寄せに
// - calendar-picker-indicator:ml-auto  : ピッカーアイコンを右端に固定
const fieldCls =
  'h-10 appearance-none [&::-webkit-date-and-time-value]:text-left [&::-webkit-calendar-picker-indicator]:ml-auto'

export default function DateTimeField({
  label,
  dateField,
  timeField,
  timeLabel = '時刻',
  labelClassName = 'text-sm font-medium',
}: Props) {
  return (
    <div className="flex gap-2">
      <div className="flex-1 min-w-0 space-y-1.5">
        <label className={labelClassName}>{label}</label>
        <Input {...dateField} type="date" className={fieldCls} />
      </div>
      {timeField && (
        <div className="flex-1 min-w-0 space-y-1.5">
          <label className={labelClassName}>{timeLabel}</label>
          <Input {...timeField} type="time" className={fieldCls} />
        </div>
      )}
    </div>
  )
}
